import { useState } from 'react';
import { Anchor, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useAutomationSuiteLinks } from '@/hooks/api/automationSuites/useAutomationSuites.ts';
import { SuiteError, SuitePagination } from './SuiteShared.tsx';

export default function AutomationSuiteLinks({ automationId }: { automationId: string }) {
  const [page, setPage] = useState(1);
  const query = useAutomationSuiteLinks(automationId, page);
  return (
    <Stack gap="xs" mt="md">
      <Text fw={600}>Automation Suites</Text>
      {!query.isError && !query.isFetchedAfterMount && <Text size="sm">Loading associations…</Text>}
      {query.isError && <SuiteError error={query.error} retry={() => void query.refetch()} />}
      {!query.isError && query.isFetchedAfterMount && query.data && (
        <>
          {!query.data.results.length && (
            <Text size="sm" c="dimmed">
              No explicit Suite memberships.
            </Text>
          )}
          {query.data.results.map((suite) => (
            <Anchor key={suite.id} component={Link} to={`/automation-suites/${suite.id}`}>
              {suite.name ?? 'Restricted Suite'}
              {suite.archived_at ? ' (archived)' : ''}
            </Anchor>
          ))}
          {(query.data.next || query.data.previous) && (
            <SuitePagination data={query.data} onPage={setPage} />
          )}
        </>
      )}
    </Stack>
  );
}
